import { AddressElements } from './address-elements';
import { GeoCoordinates } from './geo-coordinates';
import { LocationProvider } from './location-provider';

export interface LocationDataGeocoded extends LocationData {
  addressElements: AddressElements;
  geoCoordinates: GeoCoordinates;
  timezone?: string;
}

export interface LocationData {
  isKnownAddress: boolean;
  locationProvider: LocationProvider;
  placeId: string;
  address: string;
  isCompleteAddress: boolean;
}

export interface CountryBounds {
  north: number;
  south: number;
  east: number;
  west: number;
}
